import React from 'react'
import {
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    NumberDecrementStepper,
    NumberIncrementStepper
} from '@chakra-ui/react'

interface Props {
    valueForm: string | number
    placeholder: string
    handleChange: (
        value: string,
        index: number,
        name: string,
        maxValue?: number
    ) => void
    name: string
    precision?: number
    index: number
    isReadOnly?: boolean
    max?: number
    min?: number
}

export default function CustomNumberInput({
    handleChange,
    valueForm,
    placeholder,
    name,
    precision = 0,
    index,
    isReadOnly = false,
    max,
    min = 0
}: Props) {
    return (
        <NumberInput
            onChange={value => handleChange(value, index, name, max)}
            placeholder={placeholder}
            value={valueForm}
            precision={precision}
            min={min}
            max={max}
            isReadOnly={isReadOnly}
            isDisabled={isReadOnly}
        >
            <NumberInputField />
            <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
            </NumberInputStepper>
        </NumberInput>
    )
}
